import React from "react";
import {Box, Button, Columns} from "react-bulma-components";
import Collapsible from "react-collapsible";
import useInput from "../../../hooks/useInput";
import usePostVehicleMake from "../../../hooks/usePostVehicleMake";
import usePostRentalMargin from "../../../hooks/usePostRentalMargin";


export default function NewRentalMargin(){

    let [name, nameInput, setName] = useInput({
        type: "text",
        label: "Name"
    });

    let [margin, marginInput, setMargin] = useInput({
        type: "number",
        label: "Margin (%)",
        initialValue: 0.1,
        currency: true
    });


    const clear = () =>{
        setName("");
        setMargin(40)
    }
    const [, postMake] = usePostRentalMargin({
        name: name,
        margin: margin
    })
    const handleSubmit = () => {
        postMake().then(() => (
            clear()
        ))
    }

    return (
        <Box className="settings_type">
          <Collapsible
            className="title"
            triggerOpenedClassName="title"
            trigger="Add Rental Margin"
          >
              <Columns>
                  {nameInput}
                  {marginInput}
              </Columns>
              <Columns>
                <Columns.Column>
                    <Button
                        color={"success"}
                        fullwidth
                        onClick={handleSubmit}
                    >
                        Add +
                    </Button>
                </Columns.Column>
              </Columns>
          </Collapsible>
        </Box>
    )
}